import { useState, useEffect } from 'react';
import Slide from '../../../components/layout/Slide';
import { GoogleMap } from '../../../components/layout/map/GoogleMap';
import { useNavigate } from 'react-router';

export default function PilotagePecExamsInfo({ pecExam }) {

    const navigate = useNavigate();
    const [showMap, setShowMap] = useState(false);
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        function handleOnOffline() {
            setIsOnline(navigator.onLine);
        }

        window.addEventListener("offline", handleOnOffline);
        window.addEventListener("online", handleOnOffline);

        return () => {
            window.removeEventListener("offline", handleOnOffline);
            window.removeEventListener("online", handleOnOffline);
        };
    }, [])

    return (
        <>
            <div className="m-b-8">
                <div className="pecExam-information">
                    <div className="pilot-name">{`${pecExam.examPerson}`}</div>
                    <div className="link" onClick={() => navigate("/evaluation")}>
                        Evaluering
                    </div>
                </div>
                <div className="pecExam-location-to">
                    <div>{`${pecExam.examName}`}</div>
                    {isOnline && (
                        <>
                            <div>
                                <div className="link" onClick={() => setShowMap(!showMap)}>
                                    {showMap ? "Skjul" : "Vis"}&nbsp;område
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            {isOnline && (
                <Slide show={showMap}>
                    <div>
                        <GoogleMap height={400} isInline={true} minZoom={5} zoom={7} pecExam={pecExam} />
                    </div>
                </Slide>
            )}
        </>
    );
}
